module.exports = require("deep-extend");


//////////////////
// WEBPACK FOOTER
// external "deep-extend"
// module id = 172
// module chunks = 0